import { ResponsiveTextModule } from '@/src/types/common/content';
import { EnumModuleType } from '@/src/types/common/module';

type Params = {
  pc: ResponsiveTextModule;
  tablet: ResponsiveTextModule;
  mobile: ResponsiveTextModule;
  moduleType: EnumModuleType;
};

class TextStrategy {
  assign(obj: any, target: any) {
    Object.assign(obj, target);
  }

  invokeStrategy({ pc, tablet, mobile }: Params) {
    const _tablet = tablet;
    const _mobile = mobile;
    const {
      h1TagEnabled, // visible,
      moduleStyle,
    } = pc;
    this.assign(_tablet, {
      //  visible,
      h1TagEnabled,
      moduleStyle: {
        ...tablet.moduleStyle,
        backgroundType: moduleStyle?.backgroundType,
        backgroundColor: moduleStyle?.backgroundColor,
      },
    });
    this.assign(_mobile, {
      // visible,
      h1TagEnabled,
      moduleStyle: {
        ...mobile.moduleStyle,
        backgroundType: moduleStyle?.backgroundType,
        backgroundColor: moduleStyle?.backgroundColor,
      },
    });
    return {
      pc,
      tablet: _tablet,
      mobile: _mobile,
    };
  }
}

export default new TextStrategy();
